import { Injectable, computed, inject, signal } from "@angular/core";
import { Title } from "@angular/platform-browser";
import {
  ActivatedRouteSnapshot,
  NavigationEnd,
  Router,
} from "@angular/router";
import { filter, map } from "rxjs/operators";

const BRAND = "Registramed";

function coerceTitle(raw: unknown): string | undefined {
  if (raw == null) return undefined;
  const s = String(raw).trim();
  return s.length > 0 ? s : undefined;
}

/**
 * Sincroniza `document.title` con `data.title` de la ruta más profunda
 * y expone el mismo texto para la barra superior (header).
 */
@Injectable({ providedIn: "root" })
export class AppPageTitleService {
  private readonly router = inject(Router);
  private readonly title = inject(Title);

  private readonly contextFragment = signal<string>("");

  readonly headerTitle = computed(() => this.contextFragment() || BRAND);

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        map(() =>
          this.resolveDeepestTitle(this.router.routerState.snapshot.root),
        ),
      )
      .subscribe((fragment) => {
        this.contextFragment.set(fragment ?? "");
        const doc = fragment ? `${fragment} | ${BRAND}` : BRAND;
        this.title.setTitle(doc);
      });
  }

  private resolveDeepestTitle(
    root: ActivatedRouteSnapshot | null,
  ): string | undefined {
    let last: string | undefined;
    let route: ActivatedRouteSnapshot | null = root;
    while (route) {
      const t = coerceTitle(route.data["title"]);
      if (t) last = t;
      route = route.firstChild ?? null;
    }
    return last;
  }
}
